import jQuery from 'jquery';
window.$ = jQuery;

import Chart from 'chart.js/auto';
window.Chart = Chart;

import axios from 'axios';
window.axios = axios;

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

import { Html5Qrcode } from "html5-qrcode";
window.Html5Qrcode = Html5Qrcode;

import iro from '@jaames/iro';
window.iro = iro;

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allow your team to quickly build robust real-time web applications.
 */

import './echo';
